import { memo } from 'react';
import Modal from './Modal'
import { QRCodeSVG } from 'qrcode.react';

import { BulkBatch } from '../pages/Form/EditBatchNo'
import { EditorProps } from 'react-data-grid'

export default memo(function QRCodeFGModal({ props } : {
  props: EditorProps<BulkBatch>
}) {
  const { row, onClose } = props
  const actualLot = row.newBatchNo || row.currentBatchNo
  const fgShelfLife = row.shelfLifeMonth
  const fgCode = row.fgCode
  const qrCodeContent = [actualLot, fgShelfLife, fgCode].join('|')

  return (
    <Modal
    show={true}
    onHide={onClose}
    cancelText='ปิด'
    cancelAction={onClose}
    title='QR Code for Laser Marking'
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <QRCodeSVG value={qrCodeContent} size={300} />
        <div className='text-xs text-muted'>{qrCodeContent}</div>
        <div className="flex flex-col items-center justify-center w-full gap-3">
          <p className='font-bold '>สแกน QR Code เพื่อดึงข้อมูล FG</p>
          <div className="grid w-full grid-cols-2 gap-4">
            <div>
              <p className=''>FG Code</p>
              <p className='text-2xl font-bold '>{fgCode}</p>
            </div>
            <div>
              <p className=''>Lot No.</p>
              <p className='text-2xl font-bold '>{actualLot}</p>
            </div>
            <div>
              <p className=''>Shelf Life</p>
              <p className='text-2xl font-bold '>{fgShelfLife} เดือน</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
})